const formatDate = (value) => {
    if (value === null || value === undefined) return '-';
  
    const raw = String(value).trim();
    if (!raw || raw === 'Invalid date' || raw === 'Invalid Date') return '-';
  
    let date;
  
    if (/^\d{4}-\d{2}-\d{2}/.test(raw)) {
      const [year, month, day] = raw.slice(0, 10).split('-').map(Number);
      date = new Date(year, month - 1, day);
    } else if (value instanceof Date) {
      date = value;
    } else {
      date = new Date(raw);
    }
  
    if (Number.isNaN(date.getTime())) return '-';
  
    return new Intl.DateTimeFormat('es-PE', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    }).format(date);
  };
  
  export default formatDate;